module.exports = __webpack_public_path__ + "static/img/header.f9469bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header.png
// module id = 12
// module chunks = 0